import { gsap } from 'gsap'

import Page from './../../classes/Page'

export default class extends Page {
  constructor () {
    super({
      id: 'default',

      classes: {
        active: 'project--active',
        buttonActive:'is-active',
      },

      element: '#main',
      elements: {
        // default: '.default',
        filterButtons: '[filter-button]',
        activeCategory: '[data-active-category]',
        projectFooter: '[data-project-footer]'
      }
    })
  }

  create () {
    super.create()

    // Use the page's own data-template rather than querying for lazy-loaded
    // Livewire component markup, which may not exist in the DOM yet.
    this.isIndex = this.element.dataset.template === 'project-index' // project/index view
    this.isShow = document.querySelector('.c-project--single') ? true : false // project/show_archival view
    this.isShowArchive = document.querySelector('.c-project--archive') ? true : false // project/show_archival view

    console.log('create PROJECT page');

  }

  /**
   * Animations.
   */
  show (scrollHistory) {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.25
    }

    // Captured before the reset below, for use inside the async import's
    // .then() — by the time that runs, this.isPopState has already been
    // set back to false.
    const arrivedViaPopState = this.isPopState

    this.isPopState = false
    this.timelineIn = new gsap.timeline()

    if (this.isIndex) { // projects/index view
      import(
        '../../components/ProjectFeed.js' /* webpackChunkName: "components/ProjectFeed" */
      ).then((ProjectFeed) => {
        this.projectFeed = new ProjectFeed.default()

        // This feed is loaded with lazy="true" (deliberately, so a very
        // long project list doesn't hurt initial load) — its content only
        // exists once its placeholder intersects the viewport and its own
        // AJAX round-trip completes. That makes restoring an exact saved
        // scroll/anchor position here unreliable: the saved position can
        // sit well past where the still-empty placeholder is, so it may
        // never intersect and boot at all. Rather than a multi-stage
        // wait-for-boot-then-restore sequence, back/forward navigation
        // into this page just lands at the top — overriding whatever the
        // app-level scroll restore already set — which lets the
        // placeholder boot normally and keeps this page simple.
        if (arrivedViaPopState) {
          window.scrollTo(0, 0)

          // Forcing the position above is indistinguishable, to the shared
          // save-before-leaving logic, from the user genuinely having
          // scrolled to 0 — so without this, the next time this page is
          // left, that logic silently overwrites whatever real position
          // was saved here with 0. Since it's never read back for
          // restoration on this page anyway, drop it instead of leaving a
          // wrong number sitting there to overwrite.
          if (scrollHistory) {
            const index = scrollHistory.positions.findIndex(x => x.id == window.location.href)
            if (index > -1) {
              scrollHistory.positions.splice(index, 1)
            }
          }
        }

        this.timelineIn
        .to(this.element, {
          duration: this.duration,
          autoAlpha: 1
        })
        // .to(this.elements.projectFooter, {
        //   duration: this.duration,
        //   autoAlpha: 1
        // })
      })
    } else if (this.isShowArchive) { // projects/show_archival view
      import(
        '../../components/ProjectArchive.js' /* webpackChunkName: "components/ProjectArchive" */
      ).then((projectArchiveView) => {
        this.projectArchive = new projectArchiveView.default()

        this.timelineIn.to(this.element, {
          duration: this.duration,
          autoAlpha: 1
        })
      })
    } else { //projects/show.antlers view
      this.timelineIn.to(this.element, {
        duration: this.duration,
        autoAlpha: 1
      })
    }

    console.log('this.projectFeed', this.projectFeed)

    return super.show(this.timelineIn)
  }

  hide () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.5
    }

    this.timelineOut = new gsap.timeline()

    this.timelineOut.to(this.element, {
      duration: this.duration,
      autoAlpha: 0
    })

    this.timelineOut.call(() => {
      this.destroy()
    })

    return super.hide(this.timelineOut)
  }

  /**
   * Events.
   */
  onTouchDown (event) {

    if (this.isIndex) {
      /* Filter Button States */
      if (event.target.closest('[filter-button]')) {
        console.log('clicked the filter')
        this.elements.filterButtons.forEach(button => {
          button.classList.remove('is-active')
        })
        event.target.classList.add('is-active')
      }
    }

  }

  onPopState () {
    this.isPopState = true

    // Only teardown here — this fires on the outgoing page, which is still
    // fully visible and whose DOM is about to be replaced. Stop the
    // observer and undo the clone/tween state before that happens;
    // anything that changes what's visibly on screen (scroll position,
    // filter button state) now happens in show(), on the incoming page,
    // before it's revealed.
    if (!document.body.classList.contains('is-mobile') && this.isIndex) {
      this.projectFeed.killTweensOf()
      this.projectFeed.resetClonedItems(true)
      this.projectFeed.reinstateEvents()
      this.projectFeed.destroyLoadMoreObserver()
    }
  }

  initFilterState () {
    // Re-query rather than use this.elements: for a lazy-loaded Livewire
    // component, these selectors don't exist in the DOM at create() time.
    const activeCategoryEl = this.element.querySelector('[data-active-category]')
    const filterButtons = this.element.querySelectorAll('[filter-button]')

    this.elements.activeCategory = activeCategoryEl
    this.elements.filterButtons = filterButtons

    if (!activeCategoryEl) return

    /* set initial category on filterButtons */
    this.category = activeCategoryEl.getAttribute('data-active-category')
    filterButtons.forEach(button => {
      button.classList.remove(this.classes.buttonActive)
      if (this.category == button.dataset.category) {
        button.classList.add(this.classes.buttonActive)
      }
    })
  }

  addEventListeners () {

    Livewire.on('projects-init', category => {
      this.initFilterState()

      if (this.projectFeed) {
        this.projectFeed.init()
      }
        // alert('A post was InIt with the id of: ' + category);
    })

    Livewire.on('projects-updated', category => {
      this.initFilterState()

      if (!document.body.classList.contains('is-mobile')) {
        this.projectFeed.introTimeline()
        this.projectFeed.resetClonedItems(true)
        this.projectFeed.setLoadMoreObserver()
      }
    })

    // if (this.isShowArchive) {
    //   this.projectArchive.addEventListeners()
    // }

  }

  removeEventListeners() {
    if (this.isShowArchive && this.projectArchive) {
      this.projectArchive.destroy()
    }

  }
  
  /**
   * Destroy.
   */
  destroy () {
    super.destroy()
    this.removeEventListeners()
  }
}
